import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import LogRocket from 'logrocket';
import { getLocale, loadLocaleData } from './util';
import mixpanel from "mixpanel-browser";

if (process.env.NODE_ENV !== 'development') {
  try {
    LogRocket.init('isis/isis');
    mixpanel.init("4eb2311130808d00abff9ed79b02f0e4", {
      debug: false,
      track_pageview: true,
      persistence: "localStorage",
    });
  } catch (e) {
    console.error("LogRocket initialization failed", e);
  }
}

async function bootstrap(locale: string | undefined) {
  const messages = await loadLocaleData(locale);

  ReactDOM.render(
    <React.StrictMode>
      <App locale={locale} messages={messages} />
    </React.StrictMode>,
    document.getElementById('root')
  );

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
}

bootstrap(getLocale());